import React from 'react';

function HemoglobinForm() {
  return (
    <div>
      <h2>HemoglobinForm</h2>
    </div>
  );
}

export default HemoglobinForm;
